import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const HostelDashboard = lazyPage(() => import('@/pages/hostel/Dashboard'));
const HostelBlocks = lazyPage(() => import('@/pages/hostel/Blocks'));
const HostelRooms = lazyPage(() => import('@/pages/hostel/Rooms'));
const HostelBeds = lazyPage(() => import('@/pages/hostel/Beds'));
const HostelAllocation = lazyPage(() => import('@/pages/hostel/Allocation'));
const HostelAttendance = lazyPage(() => import('@/pages/hostel/Attendance'));
const HostelMealManagement = lazyPage(() => import('@/pages/hostel/MealManagement'));
const HostelStaff = lazyPage(() => import('@/pages/hostel/Staff'));
const HostelVisitors = lazyPage(() => import('@/pages/hostel/Visitors'));
const HostelComplaints = lazyPage(() => import('@/pages/hostel/Complaints'));
const HostelMaintenance = lazyPage(() => import('@/pages/hostel/Maintenance'));
const HostelReports = lazyPage(() => import('@/pages/hostel/Reports'));

export const hostelRoutes: AppRoute[] = [
  {
    path: 'hostel',
    title: 'Hostel / Boarding',
    children: [
      { path: '', title: 'Hostel / Boarding', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: HostelDashboard },
      { path: 'blocks', title: 'Blocks', component: HostelBlocks },
      { path: 'rooms', title: 'Rooms', component: HostelRooms },
      { path: 'beds', title: 'Beds', component: HostelBeds },
      { path: 'allocation', title: 'Allocation', component: HostelAllocation },
      { path: 'attendance', title: 'Attendance', component: HostelAttendance },
      { path: 'meals', title: 'Meal Management', component: HostelMealManagement },
      { path: 'staff', title: 'Staff', component: HostelStaff },
      { path: 'visitors', title: 'Visitors', component: HostelVisitors },
      { path: 'complaints', title: 'Complaints', component: HostelComplaints },
      { path: 'maintenance', title: 'Maintenance', component: HostelMaintenance },
      { path: 'reports', title: 'Hostel Reports', component: HostelReports },
    ],
  },
];
